// InventoryAdminInventory - User Activity Component
import React from 'react';
import '../../../../assests/css/admin/Analytics/UserAcitivity/UserActivity.css';

const UserActivity = () => {
  const activityPercentage = 72.4;
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (activityPercentage / 100) * circumference;

  const stats = [
    { label: 'Active', value: '18,402', indicator: 'active' },
    { label: 'Idle', value: '4,192', indicator: 'idle' },
    { label: 'Away', value: '2,084', indicator: 'away' }
  ];

  const members = [
    { 
      name: 'Alex Smith', 
      role: 'Product Manager', 
      avatar: 'AS', 
      avatarColor: 'blue',
      status: 'online',
      time: 'Online'
    },
    { 
      name: 'Mia Konte', 
      role: 'UI Designer', 
      avatar: 'MK', 
      avatarColor: 'orange',
      status: 'online',
      time: '2m ago'
    }
  ];

  return (
    <div className="InventoryAdminInventory-user-activity">
      <div className="InventoryAdminInventory-activity-header">
        <div className="InventoryAdminInventory-activity-title">User Activity</div>
        <div className="InventoryAdminInventory-activity-badge">
          <span>●</span>
          <span>LIVE NOW</span>
        </div>
      </div>

      <div className="InventoryAdminInventory-activity-content">
        <div className="InventoryAdminInventory-donut-container">
          <svg className="InventoryAdminInventory-donut-chart" viewBox="0 0 160 160">
            <circle
              className="InventoryAdminInventory-donut-background"
              cx="80"
              cy="80"
              r={radius}
            />
            <circle
              className="InventoryAdminInventory-donut-segment"
              cx="80"
              cy="80"
              r={radius}
              stroke="url(#gradient)"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#3b82f6" />
              </linearGradient>
            </defs>
          </svg>
          <div className="InventoryAdminInventory-donut-center">
            <span className="InventoryAdminInventory-donut-percentage">
              {activityPercentage}%
            </span>
            <div className="InventoryAdminInventory-donut-label">Active Rate</div>
          </div>
        </div>

        <div className="InventoryAdminInventory-activity-stats">
          {stats.map((stat, index) => (
            <div key={index} className="InventoryAdminInventory-stat-item">
              <div className={`InventoryAdminInventory-stat-indicator ${stat.indicator}`}></div>
              <div className="InventoryAdminInventory-stat-info">
                <div className="InventoryAdminInventory-stat-label">{stat.label}</div>
              </div>
              <div className="InventoryAdminInventory-stat-value">{stat.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="InventoryAdminInventory-activity-members">
        <div className="InventoryAdminInventory-members-header">
          <div className="InventoryAdminInventory-members-title">Recent Members</div>
          <div className="InventoryAdminInventory-members-link">Full List →</div>
        </div>
        
        {members.map((member, index) => (
          <div key={index} className="InventoryAdminInventory-member-item">
            <div className={`InventoryAdminInventory-member-avatar ${member.avatarColor}`}>
              {member.avatar}
              <div className={`InventoryAdminInventory-status-dot ${member.status}`}></div>
            </div>
            <div className="InventoryAdminInventory-member-info">
              <div className="InventoryAdminInventory-member-name">{member.name}</div>
              <div className="InventoryAdminInventory-member-role">{member.role}</div>
            </div>
            <div className="InventoryAdminInventory-member-time">{member.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserActivity;